module.exports = __webpack_public_path__ + "static/img/cart.2eecea7c.svg";